/* VueXtend theme helpers */
(function () {
  var root = document.documentElement;
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      root.classList.toggle('vx-scrolled', window.scrollY > 24);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Keep only one FAQ item open at a time within a group */
  document.addEventListener('toggle', function (e) {
    var el = e.target;
    if (!el.matches || !el.matches('details.vx-faq__item') || !el.open) return;
    var group = el.closest('[data-vx-accordion="single"]');
    if (!group) return;
    group.querySelectorAll('details.vx-faq__item[open]').forEach(function (d) {
      if (d !== el) d.open = false;
    });
  }, true);

  /* Tabs (use cases): progressive enhancement, arrow keys move between tabs */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initTabs(scope) {
    scope.querySelectorAll('[data-vx-tabs]:not(.is-ready)').forEach(function (wrap) {
      var list = wrap.querySelector('[role="tablist"]');
      if (!list) return;
      var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.classList.toggle('is-active', on);
        });
        if (focus) tab.focus();
        // On narrow screens the tab row scrolls sideways: move the chosen tab to the start
        // so the next one along comes into view (without scrolling the page itself)
        if (list.scrollWidth > list.clientWidth + 1) {
          var pad = parseFloat(getComputedStyle(list).paddingLeft) || 0;
          var left = list.scrollLeft + tab.getBoundingClientRect().left - list.getBoundingClientRect().left - pad;
          var max = list.scrollWidth - list.clientWidth;
          list.scrollTo({ left: Math.max(0, Math.min(left, max)), behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') next = tabs[0];
          if (e.key === 'End') next = tabs[tabs.length - 1];
          if (next) { e.preventDefault(); select(next, true); }
        });
      });
      list.hidden = false;
      wrap.classList.add('is-ready');

      // Auto-rotate: next tab every few seconds, looping. Pauses on hover/focus, off screen or in a
      // background browser tab, and stops for good once the visitor picks a tab themselves.
      var secs = parseFloat(wrap.getAttribute('data-vx-autoplay')) || 0;
      if (secs > 0 && !reduceMotion && tabs.length > 1) {
        var timer = null, paused = false, visible = false, stopped = false, held = false;
        var schedule = function () {
          clearTimeout(timer);
          wrap.classList.remove('is-timing');
          if (stopped || paused || held || !visible || document.hidden) return;
          void wrap.offsetWidth; // restart the progress bar animation
          wrap.classList.add('is-timing');
          timer = setTimeout(function () {
            var cur = 0;
            tabs.forEach(function (t, i) { if (t.getAttribute('aria-selected') === 'true') cur = i; });
            select(tabs[(cur + 1) % tabs.length]);
            schedule();
          }, secs * 1000);
        };
        var stop = function () { stopped = true; schedule(); };
        wrap.style.setProperty('--vx-tab-time', secs + 's');
        tabs.forEach(function (t) { t.addEventListener('click', stop); t.addEventListener('keydown', stop); });
        list.addEventListener('wheel', stop, { passive: true });
        // Touch: hold while a finger is on the tabs or panel, carry on when it lifts
        var hold = function () { held = true; wrap.classList.add('is-held'); schedule(); };
        var release = function () { if (!held) return; held = false; wrap.classList.remove('is-held'); schedule(); };
        wrap.addEventListener('touchstart', hold, { passive: true });
        wrap.addEventListener('touchend', release, { passive: true });
        wrap.addEventListener('touchcancel', release, { passive: true });
        // Mouse hover pauses on desktop only (touch taps fire fake mouse events)
        wrap.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { paused = true; schedule(); } });
        wrap.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { paused = false; schedule(); } });
        wrap.addEventListener('focusin', function () { paused = true; schedule(); });
        wrap.addEventListener('focusout', function (e) { if (!wrap.contains(e.relatedTarget)) { paused = false; schedule(); } });
        document.addEventListener('visibilitychange', schedule);
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            visible = entries[0].isIntersecting; schedule();
          }, { threshold: 0.35 }).observe(wrap);
        } else { visible = true; schedule(); }
      }
    });
  }

  /* Before / after slider */
  function initCompare(scope) {
    scope.querySelectorAll('[data-vx-ba]').forEach(function (el) {
      var range = el.querySelector('.vx-ba__range');
      if (!range || range.dataset.ready) return;
      range.dataset.ready = '1';
      range.addEventListener('input', function () { el.style.setProperty('--pos', range.value + '%'); });
      initCompareAuto(el, range);
    });
  }

  /* Before / after auto slide: full right > full left > full right, looping (no stop in the centre) */
  function initCompareAuto(el, range) {
    var speedKey = el.getAttribute('data-vx-ba-auto');
    if (!speedKey || reduceMotion) return;
    var speed = { slow: 16, medium: 26, fast: 40 }[speedKey] || 26; /* % of width per second */
    var path = [100, 0];
    var step = 0, pos = parseFloat(range.value) || 50, from = pos, to = path[0], t0 = null, dur = 0;
    var visible = false, paused = false, raf = null, resumeTimer = null;
    function ease(x) { return 0.5 - Math.cos(Math.PI * x) / 2; }
    function set(v) { pos = v; el.style.setProperty('--pos', v.toFixed(2) + '%'); range.value = Math.round(v); }
    function leg(target) { from = pos; to = target; t0 = null; dur = Math.max(400, Math.abs(to - from) / speed * 1000); }
    function frame(ts) {
      raf = null;
      if (!visible || paused) return;
      if (t0 === null) t0 = ts;
      var k = Math.min(1, (ts - t0) / dur);
      set(from + (to - from) * ease(k));
      if (k >= 1) { step = (step + 1) % path.length; leg(path[step]); }
      raf = requestAnimationFrame(frame);
    }
    function run() { if (!raf && visible && !paused) raf = requestAnimationFrame(frame); }
    function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } t0 = null; }
    function hold() {
      paused = true; stop(); clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; pos = parseFloat(range.value) || pos; step = pos < 50 ? 0 : 1; leg(path[step]); run(); }, 4000);
    }
    ['pointerdown', 'touchstart', 'keydown', 'input'].forEach(function (ev) { range.addEventListener(ev, hold, { passive: true }); });
    leg(to);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) { leg(to); run(); } else stop();
      }, { threshold: 0.25 }).observe(el);
    } else { visible = true; run(); }
  }

  /* Model finder */
  function recommend(size, where, who) {
    if (who === 'team') return 'business';
    if (size === 'large') return 'max';
    if (size === 'small') return where === 'desk' ? 'max' : 'air';
    if (where === 'travel') return 'air';
    if (where === 'desk') return 'max';
    return 'pro';
  }
  function initFinder(scope) {
    scope.querySelectorAll('[data-vx-finder]').forEach(function (wrap) {
      var form = wrap.querySelector('form');
      if (!form || form.dataset.ready) return;
      form.dataset.ready = '1';
      var empty = wrap.querySelector('[data-vx-finder-empty]');
      var count = wrap.querySelector('[data-vx-finder-count]');
      function val(name) { var c = form.querySelector('input[name="' + name + '"]:checked'); return c ? c.value : null; }
      function update() {
        var a = [val('size'), val('where'), val('who')];
        var answered = a.filter(Boolean).length;
        if (count) count.textContent = answered;
        var key = answered === 3 ? recommend(a[0], a[1], a[2]) : null;
        var shown = false;
        wrap.querySelectorAll('[data-vx-result]').forEach(function (r) {
          var on = !shown && r.getAttribute('data-vx-result') === key;
          r.hidden = !on;
          if (on) shown = true;
        });
        if (empty) empty.hidden = shown;
        wrap.classList.toggle('has-result', shown);
      }
      form.addEventListener('change', update);
      form.addEventListener('submit', function (e) { e.preventDefault(); });
      form.addEventListener('reset', function () { setTimeout(update, 0); });
      update();
    });
  }

  /* Countdown for a real, merchant-set offer end date */
  function initCountdowns(scope) {
    scope.querySelectorAll('[data-vx-countdown]').forEach(function (el) {
      if (el.dataset.ready) return;
      var end = Date.parse(el.getAttribute('data-vx-countdown'));
      if (isNaN(end)) return;
      el.dataset.ready = '1';
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) { el.hidden = true; return false; }
        el.hidden = false;
        el.querySelector('[data-d]').textContent = pad(Math.floor(left / 86400));
        el.querySelector('[data-h]').textContent = pad(Math.floor(left % 86400 / 3600));
        el.querySelector('[data-m]').textContent = pad(Math.floor(left % 3600 / 60));
        el.querySelector('[data-s]').textContent = pad(left % 60);
        return true;
      }
      if (tick()) { var id = setInterval(function () { if (!tick()) clearInterval(id); }, 1000); }
    });
  }

  /* Gentle reveal on scroll (skipped when the visitor prefers reduced motion) */
  function initReveal(scope) {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var items = scope.querySelectorAll('.vx-section .vx-head, .vx-model, .vx-plan, .vx-review, .vx-step, .vx-feature, .vx-promise__item, .vx-value');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) {
      if (el.classList.contains('vx-reveal')) return;
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) return; /* already on screen: never hide it */
      el.classList.add('vx-reveal');
      io.observe(el);
    });
  }

  function initAll(scope) {
    initTabs(scope); initCompare(scope); initFinder(scope); initCountdowns(scope);
  }
  initAll(document);
  initReveal(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  /* Hero: only the visible video (desktop or mobile) plays */
  var heroVideos = document.querySelectorAll('.vx-hero__video');
  if (heroVideos.length > 1) {
    var syncHero = function () {
      heroVideos.forEach(function (v) {
        if (v.offsetParent === null) { v.pause(); }
        else if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    };
    syncHero();
    window.matchMedia('(max-width: 749px)').addEventListener('change', syncHero);
  }

  /* Back to top: appears after scrolling down, smooth-scrolls up */
  var toTop = document.querySelector('[data-vx-totop]');
  if (toTop) {
    toTop.hidden = false;
    var syncTop = function () { toTop.classList.toggle('is-visible', window.scrollY > Math.max(600, window.innerHeight)); };
    window.addEventListener('scroll', syncTop, { passive: true });
    syncTop();
    toTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      var target = document.getElementById('MainContent') || document.body;
      if (target && target.focus) { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
    });
  }

  /* Videos with a start time: begin there and loop back to it instead of to 0 */
  function initVideoStart(scope) {
    scope.querySelectorAll('[data-vx-start] video').forEach(function (v) {
      if (v.dataset.vxStartReady) return;
      v.dataset.vxStartReady = '1';
      var start = parseFloat(v.closest('[data-vx-start]').getAttribute('data-vx-start')) || 0;
      if (!start) return;
      var seek = function () { if (v.duration && start < v.duration) v.currentTime = start; };
      if (v.readyState >= 1) seek(); else v.addEventListener('loadedmetadata', seek, { once: true });
      if (v.loop) {
        v.loop = false;
        v.addEventListener('ended', function () { seek(); var p = v.play(); if (p && p.catch) p.catch(function () {}); });
      }
    });
  }
  initVideoStart(document);
  document.addEventListener('shopify:section:load', function (e) { initVideoStart(e.target); });

  /* Product family picker: load the chosen model and swap the page content in place */
  var vxSwapped = false;
  function vxSwap(url, push, toTop) {
    var main = document.getElementById('MainContent');
    if (!main) { window.location.href = url; return; }
    main.classList.add('vx-swapping');
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.getElementById('MainContent');
        if (!next) throw new Error('no main');
        var y = window.scrollY;
        main.innerHTML = next.innerHTML;
        if (doc.title) document.title = doc.title;
        if (push) history.pushState({ vxSwap: true }, '', url);
        vxSwapped = true;
        initAll(main);
        initVideoStart(main);
        if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') window.Shopify.PaymentButton.init();
        main.classList.remove('vx-swapping');
        if (toTop) window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); else window.scrollTo(0, y);
        var cur = main.querySelector('.vx-fp__opt.is-current');
        if (cur && !toTop) cur.focus({ preventScroll: true });
      })
      .catch(function () { window.location.href = url; });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-vx-swap]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (!window.fetch || !window.DOMParser || !window.history.pushState) return;
    e.preventDefault();
    if (a.getAttribute('aria-current') === 'true') return;
    vxSwap(a.href, true, a.hasAttribute('data-vx-swap-top'));
  });
  window.addEventListener('popstate', function () { if (vxSwapped) window.location.reload(); });
})();

/* v1.2.43: open the header mega menu on hover (mouse only); click and keyboard still work via <details> */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var bind = function () {
    document.querySelectorAll('.vx-mega-li').forEach(function (li) {
      if (li.dataset.vxHover) return;
      li.dataset.vxHover = '1';
      var d = li.querySelector('details');
      if (!d) return;
      var t;
      var set = function (open) {
        if (open === d.open) return;
        if (open) d.setAttribute('open', ''); else d.removeAttribute('open');
        var s = d.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      li.addEventListener('mouseenter', function () { clearTimeout(t); t = setTimeout(function () { set(true); }, 80); });
      li.addEventListener('mouseleave', function () { clearTimeout(t); t = setTimeout(function () { set(false); }, 180); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  document.addEventListener('shopify:section:load', bind);
})();

/* v1.2.45: product image lightbox. Replaces Dawn's full-screen zoom with a 75% window,
   previous / next arrows, counter, thumbnails and a close button. Videos and 3D models keep Dawn's modal. */
(function () {
  var box, img, count, thumbs, slides = [], cur = 0, lastFocus;
  function build() {
    if (box) return;
    box = document.createElement('div');
    box.className = 'vx-lb';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Product images');
    box.hidden = true;
    box.innerHTML =
      '<div class="vx-lb__backdrop" data-vx-lb-close></div>' +
      '<div class="vx-lb__panel">' +
        '<button type="button" class="vx-lb__close" data-vx-lb-close aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<div class="vx-lb__stage">' +
          '<button type="button" class="vx-lb__nav vx-lb__nav--prev" aria-label="Previous image"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
          '<img class="vx-lb__img" alt="">' +
          '<button type="button" class="vx-lb__nav vx-lb__nav--next" aria-label="Next image"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>' +
        '</div>' +
        '<div class="vx-lb__foot"><span class="vx-lb__count" aria-live="polite"></span><div class="vx-lb__thumbs"></div></div>' +
      '</div>';
    document.body.appendChild(box);
    img = box.querySelector('.vx-lb__img');
    count = box.querySelector('.vx-lb__count');
    thumbs = box.querySelector('.vx-lb__thumbs');
    box.querySelectorAll('[data-vx-lb-close]').forEach(function (b) { b.addEventListener('click', close); });
    box.querySelector('.vx-lb__nav--prev').addEventListener('click', function () { go(cur - 1); });
    box.querySelector('.vx-lb__nav--next').addEventListener('click', function () { go(cur + 1); });
    var sx = null;
    img.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    img.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
    });
    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(cur - 1);
      else if (e.key === 'ArrowRight') go(cur + 1);
      else if (e.key === 'Tab') {
        var f = box.querySelectorAll('button'); var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }
  function go(i) {
    if (!slides.length) return;
    cur = (i + slides.length) % slides.length;
    var s = slides[cur];
    img.classList.remove('is-in');
    img.src = s.src; img.alt = s.alt;
    requestAnimationFrame(function () { img.classList.add('is-in'); });
    count.textContent = (cur + 1) + ' / ' + slides.length;
    thumbs.querySelectorAll('button').forEach(function (t, n) {
      t.classList.toggle('is-active', n === cur);
      if (n === cur) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      if (n === cur && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'center' });
    });
    var multi = slides.length > 1;
    box.classList.toggle('is-single', !multi);
  }
  function open(list, start, from) {
    build();
    slides = list; lastFocus = from;
    thumbs.innerHTML = '';
    slides.forEach(function (s, n) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'vx-lb__thumb';
      b.setAttribute('aria-label', 'Image ' + (n + 1));
      b.innerHTML = '<img src="' + s.thumb + '" alt="" loading="lazy">';
      b.addEventListener('click', function () { go(n); });
      thumbs.appendChild(b);
    });
    box.hidden = false;
    document.documentElement.classList.add('vx-lb-open');
    requestAnimationFrame(function () { box.classList.add('is-open'); });
    go(start);
    box.querySelector('.vx-lb__close').focus();
  }
  function close() {
    if (!box || box.hidden) return;
    box.classList.remove('is-open');
    box.hidden = true;
    document.documentElement.classList.remove('vx-lb-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function sized(u, w) {
    if (!u || /^data:/.test(u)) return u;
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&]width=)\d+/, '$1' + w);
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.product__media-toggle');
    if (!btn) return;
    var opener = btn.closest('modal-opener');
    var modal = opener && document.querySelector(opener.getAttribute('data-modal'));
    if (!modal) return;
    var seen = {}, list = [];
    modal.querySelectorAll('.product-media-modal__content img[data-media-id]').forEach(function (im) {
      var id = im.getAttribute('data-media-id');
      if (seen[id]) return;
      seen[id] = 1;
      var src = im.getAttribute('src') || '';
      list.push({ id: id, src: sized(src, 1800), thumb: sized(src, 160), alt: im.getAttribute('alt') || '' });
    });
    var want = btn.getAttribute('data-media-id');
    var start = -1;
    list.forEach(function (s, n) { if (s.id === want) start = n; });
    if (start < 0 || !list.length) return; // not an image: leave Dawn's modal to handle it
    e.preventDefault();
    e.stopImmediatePropagation();
    open(list, start, btn);
  }, true);
})();

/* v1.2.50 / v1.2.52: hero background videos play only on the screens they are for (data-vx-bgv = media query), so phones never download the desktop video and vice versa */
(function () {
  if (!window.matchMedia) return;
  var mqs = {};
  var mqFor = function (q) {
    q = q || '(min-width: 750px)';
    if (!mqs[q]) { mqs[q] = window.matchMedia(q); if (mqs[q].addEventListener) mqs[q].addEventListener('change', function () { sync(); }); }
    return mqs[q];
  };
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  function sync(scope) {
    (scope || document).querySelectorAll('[data-vx-bgv] video').forEach(function (v) {
      if (mqFor(v.closest('[data-vx-bgv]').getAttribute('data-vx-bgv')).matches && !still.matches) {
        if (v.preload !== 'auto') { v.preload = 'auto'; v.load(); }
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) {
        v.pause();
      }
    });
  }
  sync();
  document.addEventListener('shopify:section:load', function (e) { sync(e.target); });
})();
